import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { EVENT_TYPE } from '../../../../constants';

const useStyles = makeStyles(theme => {
  const { right, paddingLR } = theme.mixins;

  return {
    numberResultFoundText: {
      [theme.breakpoints.up('lg')]: {
        borderBottom: 'none',
        paddingBottom: 0,
        paddingTop: 10,
      },

      '& .MuiTypography-h5, .MuiTypography-h5Bold': {
        display: 'inline',
      },
    },
    horizontalCard: {
      '&:not(:last-child)': {
        marginBottom: theme.spacing(3),
      },
    },
    eventBtnColor: {
      backgroundColor: theme.mixins.DarkTurquoise(),
    },
    sectectedFilterSection: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: pxToRem(24),
      marginBottom: pxToRem(22),
    },
    filters: {
      paddingTop: pxToRem(5),
      paddingBottom: pxToRem(5),
      ...theme.mixins.paddingLR(pxToRem(20), pxToRem(40)),
      background: theme.mixins.Grey(100),
      marginBottom: 10,
      borderRadius: borderRadius.b3px,
      position: 'relative',

      '&:not(:last-child)': {
        ...theme.mixins.marginRight(pxToRem(20)),
      },
      '& .MuiTypography-labelBlack': {
        color: theme.palette.common.SeaPort,
        textTransform: 'uppercase',
      },
    },
    crossIcon: {
      position: 'absolute',
      top: '50%',
      ...right(pxToRem(13)),
      width: pxToRem(20),
      height: pxToRem(20),
      cursor: 'pointer',
      transform: 'translate(0, -50%)',
    },
    loadMoreSection: {
      display: 'flex',
      justifyContent: 'center',

      '& button': {
        marginTop: theme.spacing(3),
        padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
        position: 'relative',

        '&:hover': {
          [theme.breakpoints.down('md')]: {
            backgroundColor: ({ contentType }) => contentType === EVENT_TYPE ?
              theme.mixins.DarkTurquoise() : theme.mixins.AbuDhabiOrange(),
          },
        },
        '& .MuiButton-label': {
          fontFamily: theme.custom.fontFamily.primaryBold,

          '& .MuiButton-endIcon': {
            '&:before': {
              display: 'block',
              position: 'absolute',
              top: pxToRem(13),
              ...right(pxToRem(29)),
              width: pxToRem(10),
              height: pxToRem(10),
              transform: 'rotate(-45deg)',
              border: `3px solid ${theme.mixins.White()}`,
              borderTop: 'none',
              borderRight: 'none',
              content: '""',

              [theme.breakpoints.up('lg')]: {
                top: pxToRem(13),
                ...right(pxToRem(26)),
              },
            },

            '& .material-icons': {
              display: 'none',
            },
          },
        },
      },
    },
    spacing: {
      width: 'auto',

      '& .MuiGrid-grid-lg-4': {
        padding: `0 ${theme.spacing(1.5)} ${theme.spacing(1.5)} 0`,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
          flex: '0 0 83.333333%',
          padding: `0 ${theme.spacing(2)}`,
          marginBottom: theme.spacing(2),
        },
      },
      [theme.breakpoints.down('md')]: {
        flexWrap: 'nowrap',
        overflowX: 'auto',
        flexDirection: 'column',
        margin: `0 ${theme.spacing(-4)}`,
        padding: `0 ${theme.spacing(2)}`,
      },
    },
    resultSpacing: {
      [theme.breakpoints.down('md')]: {
        ...paddingLR(theme.spacing(3), theme.spacing(3)),
      },
    },
    resetSpacing: {
      [theme.breakpoints.down('md')]: {
        margin: 0,
        padding: 0,
      },
    },
  };
});

export default useStyles;
